module.exports = __webpack_public_path__ + "img/74ne.244cb60c.svg";